import axios from "axios";
import {
  userInfo_url,
  API_URL
} from "../../config/index";

/**
 * 获取用户登录code
 * @param {*} param
 * appid: 公众号appid
 * state: 微信可以携带的参数，使用腾讯的携带参数比较难处理，所以使用自定义的参数
 * prop: 自定义的参数，用于携带登录成功后跳转的页面
 * 返回参数code -> 微信登录验证返回的code,用于后端解密获取公众号openid
 */
export async function getCode({ appid, state, prop }) {
  const uri = encodeURIComponent(userInfo_url + '?' + prop);
  const authURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_base&state=${state}&timestamp=${new Date().getTime()}#wechat_redirect`; //静默授权
  console.log("authURL:", uri);
  window.location.href = authURL
}


/**
 * 根据动态code登录获取用户信息
 * @param {*} param
 * code: 微信登录验证返回的code,用于后端解密获取公众号openid
 * appid: 公众号appid
 * openid: 用于与公众号openid关联的用户id字段
 * user_name: 用户姓名，传了则修改用户姓名，没传则不修改
 * phone: 用户手机号，传了则修改用户姓名，没传则不修改
 * @returns 
 */
export async function login(data) {
  var resp = await axios.post(`${API_URL}/public/wechatNotify/sendVisitor/login`, {
    ...data,
    apiKey: "719441be-26f4-4336-8fe8-c7b3098300d7"
  });
  return resp.data;
}

/**
 * 根据用户gzh_openid修改用户信息
 * @param {*} param
 * gzh_openid: 用户公众号openid
 * user_name: 姓名
 * phone: 手机号
 * is_send: 通知开关状态
 * @returns 
 */
export async function update(data) {
  var resp = await axios.post(`${API_URL}/public/wechatNotify/sendVisitor/update`, {
    ...data,
    apiKey: "719441be-26f4-4336-8fe8-c7b3098300d7"
  });
  return resp.data;
}
